import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import instagramIcon from "../assets/images/instagram_blue.svg";
import "./PrivacyPolicy.css";

function PiiPolicy() {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = "PII Policy - TLINK.ME";
    window.scrollTo(0, 0);

    return () => {
      document.title = originalTitle;
    };
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="header-content">
          <div className="header-logo">
            <Link to="/" className="logo-link">
              <h1>TLINK.ME</h1>
            </Link>
          </div>
        </div>
      </header>

      <main className="privacy-content">
        <h1 className="privacy-title">
          Personally Identifiable Information (PII) Policy – Creators &amp;
          Performers
        </h1>

        <h2 className="privacy-h2">1. Purpose</h2>
        <p className="privacy-text">
          TLINK collects and processes Personally Identifiable Information
          (PII) from performers and creators solely for legitimate business,
          legal, compliance, and payment-related purposes. This policy outlines
          what PII is collected, how it is used, and how it is protected.
        </p>

        <h2 className="privacy-h2">2. Scope</h2>
        <p className="privacy-text">
          This policy applies to all performers, creators, and individuals
          associated with creator accounts on the TLINK platform.
        </p>

        <h2 className="privacy-h2">3. Categories of PII Collected</h2>
        <p className="privacy-text">
          TLINK may collect the following categories of PII from creators:
        </p>

        <h3 className="privacy-h3">3.1 Identity &amp; Verification Information</h3>
        <ul className="privacy-ul">
          <li className="privacy-li">Full legal name</li>
          <li className="privacy-li">Date of birth</li>
          <li className="privacy-li">
            Government-issued photo identification (e.g., passport, national ID,
            driver’s license)
          </li>
          <li className="privacy-li">
            Age verification and identity confirmation data
          </li>
        </ul>

        <h3 className="privacy-h3">3.2 Contact Information</h3>
        <ul className="privacy-ul">
          <li className="privacy-li">Email address</li>
          <li className="privacy-li">Country of residence</li>
          <li className="privacy-li">
            Limited location data where required for compliance
          </li>
        </ul>

        <h3 className="privacy-h3">3.3 Payment &amp; Payout Information</h3>
        <ul className="privacy-ul">
          <li className="privacy-li">
            Payment account details (e.g., bank account, digital wallet, or
            processor account identifiers)
          </li>
          <li className="privacy-li">
            Account holder name matching verified identity
          </li>
          <li className="privacy-li">Transaction and payout history</li>
        </ul>
        <p className="privacy-text">
          TLINK does not collect or store credit card numbers or sensitive
          card data.
        </p>

        <h3 className="privacy-h3">3.4 Account &amp; Platform Information</h3>
        <ul className="privacy-ul">
          <li className="privacy-li">Creator username and account identifiers</li>
        </ul>

        <h3 className="privacy-h3">3.5 Compliance &amp; Risk Data</h3>
        <ul className="privacy-ul">
          <li className="privacy-li">
            Records related to KYC, AML, age verification, and §2257 compliance
          </li>
          <li className="privacy-li">
            Moderation or enforcement records where applicable
          </li>
        </ul>

        <h2 className="privacy-h2">4. Purpose of PII Collection</h2>
        <p className="privacy-text">PII is collected and used for the following purposes:</p>
        <ul className="privacy-ul">
          <li className="privacy-li">Identity and age verification</li>
          <li className="privacy-li">Fraud prevention and platform security</li>
          <li className="privacy-li">
            Creator onboarding and account management
          </li>
          <li className="privacy-li">
            Payment processing and payout verification
          </li>
          <li className="privacy-li">Legal and regulatory compliance</li>
        </ul>

        <h2 className="privacy-h2">5. Data Minimization</h2>
        <p className="privacy-text">
          TLINK collects only the minimum amount of PII necessary to fulfill
          its business and legal obligations and does not collect unnecessary or
          excessive personal data.
        </p>

        <h2 className="privacy-h2">6. Storage &amp; Security</h2>
        <p className="privacy-text">PII is protected through:</p>
        <ul className="privacy-ul">
          <li className="privacy-li">
            Restricted access and role-based permissions
          </li>
          <li className="privacy-li">
            Secure storage and encrypted transmission where applicable
          </li>
          <li className="privacy-li">
            Use of trusted third-party verification and payment providers
          </li>
          <li className="privacy-li">
            Ongoing monitoring for unauthorized access
          </li>
        </ul>

        <h2 className="privacy-h2">7. Sharing of PII</h2>
        <p className="privacy-text">PII may be shared only with:</p>
        <ul className="privacy-ul">
          <li className="privacy-li">
            Third-party service providers (e.g., KYC or payment processors) under
            contractual confidentiality obligations
          </li>
          <li className="privacy-li">
            Platform partners such as Telegram where required
          </li>
          <li className="privacy-li">
            Regulatory or law enforcement authorities when legally required
          </li>
        </ul>
        <p className="privacy-text">PII is not sold or shared for marketing purposes.</p>

        <h2 className="privacy-h2">8. Retention &amp; Deletion</h2>
        <p className="privacy-text">
          PII is retained only for as long as necessary to meet operational,
          legal, and regulatory requirements. Once no longer required, data is
          securely deleted or anonymized.
        </p>

        <h2 className="privacy-h2">9. Data Subject Rights</h2>
        <p className="privacy-text">
          Where applicable under law, creators may request access to, correction
          of, or deletion of their personal data, subject to legal retention
          requirements.
        </p>

        <h2 className="privacy-h2">10. Policy Review</h2>
        <p className="privacy-text">
          This policy is reviewed periodically and updated to reflect regulatory
          requirements, data protection laws, and business operations.
        </p>

        <div className="policy-navigation">
          <h3 className="policy-nav-title">Other Policies</h3>
          <div className="policy-nav-links">
            <Link to="/privacy-policy" className="policy-nav-link">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="policy-nav-link">
              Terms & Conditions
            </Link>
            <Link to="/compliance-policy" className="policy-nav-link">
              Compliance Policy
            </Link>
          </div>
        </div>
      </main>

      <footer className="privacy-footer">
        <div className="footer-content">
          <div className="footer-left">
            <span className="footer-title">FOLLOW US</span>
            <div className="footer-social">
              <img
                src={instagramIcon}
                alt="Instagram"
                className="footer-instagram-icon"
              />
              <a
                href="https://instagram.com/tlink.me"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-handle"
              >
                TLINK.ME
              </a>
            </div>
          </div>
          <div className="footer-center">
            <div className="footer-logo">TLINK.ME</div>
          </div>
          <div className="footer-right">
            <div className="footer-copyright">
              ALL RIGHTS RESERVED.
              <span className="footer-year">2025</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PiiPolicy;
